"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SearchQuery {
    constructor({ query, limit, currentPage, organizationId, onlyMyOrganization, industry, height, width, tag, contentType, scope, }) {
        this.query = query;
        this.limit = limit;
        this.currentPage = currentPage;
        this.onlyMyOrganization = onlyMyOrganization;
        this.organizationId = organizationId;
        this.industry = industry;
        this.height = height;
        this.width = width;
        this.tag = tag;
        this.contentType = contentType;
        this.scope = scope;
    }
}
SearchQuery.fromJSON = (urlQueryParam) => {
    const { query, limit, currentPage, onlyMyOrganization, organizationId, industry, height, width, tag, contentType, scope, } = Object.assign({}, urlQueryParam);
    if (query && typeof query !== 'string')
        throw new Error('.query must be a string');
    if (typeof limit !== 'number')
        throw new Error('.limit must be a number');
    if (typeof currentPage !== 'number')
        throw new Error('.currentPage must be a number');
    if (![0, 1].includes(onlyMyOrganization)) {
        throw new Error('.onlyMyOrganization must be a 0 or 1');
    }
    if (organizationId != null && !Array.isArray(organizationId)) {
        throw new Error('.organizationId must be a array');
    }
    else if (organizationId && Array.isArray(organizationId)) {
        organizationId.forEach(id => {
            if (typeof id !== 'number') {
                throw new Error('.organizationId must be a array of number');
            }
        });
    }
    if (!Array.isArray(industry)) {
        throw new Error('.industry must be a array');
    }
    else if (industry != null && Array.isArray(industry)) {
        industry.forEach(ind => {
            if (typeof ind !== 'string') {
                throw new Error('.industry must be a array of string');
            }
        });
    }
    if (!Array.isArray(height)) {
        throw new Error('.height must be a array');
    }
    else if (Array.isArray(height)) {
        if (height.length !== 2) {
            throw new Error('.height must be a array of length 2');
        }
        height.forEach(h => {
            if (typeof h !== 'number') {
                throw new Error('.height must be a array of number');
            }
        });
    }
    if (!Array.isArray(width)) {
        throw new Error('.width must be a array');
    }
    else {
        if (width.length !== 2) {
            throw new Error('.width must be a array of length 2');
        }
        width.forEach(w => {
            if (typeof w !== 'number') {
                throw new Error('.width must be a array of number');
            }
        });
    }
    if (!Array.isArray(tag)) {
        throw new Error('.tag must be a array');
    }
    else if (tag != null && Array.isArray(tag)) {
        tag.forEach(t => {
            if (typeof t !== 'string') {
                throw new Error('.tag must be a array of string');
            }
        });
    }
    if (!Array.isArray(contentType)) {
        throw new Error('.contentType must be a array');
    }
    else if (contentType != null && Array.isArray(contentType)) {
        contentType.forEach(ct => {
            if (typeof ct !== 'string') {
                throw new Error('.contentType must be a array of string');
            }
        });
    }
    if (!Array.isArray(scope)) {
        throw new Error('.scope must be a array');
    }
    else if (scope != null && Array.isArray(scope)) {
        scope.forEach(s => {
            if (typeof s !== 'number') {
                throw new Error('.scope must be a array of number');
            }
        });
    }
    return new SearchQuery(urlQueryParam);
};
exports.default = SearchQuery;
